import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../queryKeys'
import { useUserCredentials } from './useCredentials'
import type { RoutineFolder, RoutineFoldersResponse } from '../../types'

export const useRoutineFolders = () => {
  const { data: userCredentials, isLoading } = useUserCredentials()

  // Only run if user has a valid API key
  const hasValidApiKey =
    userCredentials?.apiKey &&
    userCredentials.apiKey !== 'CSV_IMPORT' &&
    userCredentials.apiKey.length > 10

  return useQuery({
    queryKey: queryKeys.routineFolders(userCredentials?.apiKey || ''),
    queryFn: async (): Promise<RoutineFolder[]> => {
      if (!userCredentials?.apiKey) {
        throw new Error('Routine folders require a configured Hevy API Key.')
      }

      const response = await fetch('https://api.hevyapp.com/v1/routine_folders', {
        headers: { 'api-key': userCredentials.apiKey }
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch routine folders: ${response.status}`)
      }

      const data: RoutineFoldersResponse = await response.json()
      return data.routine_folders
    },
    enabled: !isLoading && !!hasValidApiKey,
    retry: false // Don't retry failed API calls
  })
}